import React, { useContext, useEffect, useState } from "react";
import "../ProfilePage/profilePage.scss";
import { CgProfile } from "react-icons/cg";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import AdminName from "../../components/admin/AdminName";
import { API_BASE_URL } from "../../utils/index";
import userContext from "../../components/UseContext/UseContext";

export default function ProfilePage() {
  const { id } = useParams()
  console.log(id, "id>>>.")
  const [product, setProduct] = useState(null);
  const navigate = useNavigate();
  const { permissionvalues } = useContext(userContext);
  console.log(permissionvalues, "permissionvalues");

  const vendorsubdomain = localStorage.getItem("vendorsubdomain");
  useEffect(() => {
    const adminId = localStorage.getItem("adminId");
    const vendorsccesstoken = localStorage.getItem("vendorsccesstoken");

    const isAdminIdValid =
      adminId && adminId !== "null" && adminId !== "undefined";
    const isVendorTokenValid =
      vendorsccesstoken &&
      vendorsccesstoken !== "null" &&
      vendorsccesstoken !== "undefined";

    if (!isAdminIdValid && !isVendorTokenValid) {
      navigate(vendorsubdomain ? `/${vendorsubdomain}/login` : "/login");
    }

    const headers = {
      Authorization: `Bearer ${adminId}`,
      "Content-Type": "application/json",
    };

    axios
      .get(`${API_BASE_URL}/admin/profile`, {
        headers,
      })
      .then((result) => {
        console.log("result loki:", result.data);
        setProduct(result?.data?.admin);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);

  return (
    <div className="profile-container">
      <div className="profile px-4">
        <div className="d-flex flex-wrap">
          <div className="avatar">
            <CgProfile className="userAvatar" />
          </div>
          <div className="admin-details m-2">
            <h3 className="m-0">
              <AdminName
                product={
                  vendorsubdomain == id
                    ? permissionvalues?.companyName
                    : product?.name
                }
              />
            </h3>
            <p className="m-0">
              {vendorsubdomain == id
                ? permissionvalues?.email
                : product
                  ? product?.email
                  : "Loading..."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
